var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),(_vm.showCards)?_c('Cards',{staticClass:"animate__animated animate__fadeIn"}):_c('ContactList',{staticClass:"animate__animated animate__fadeIn"}),_c('SideViewer'),_c('PostSwipe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }